import { BenefitChangeRequestService } from '@account/services/benefit-plus/benefit-change-request.service';
import { Component, Input, OnInit } from '@angular/core';
import { BadgeOptions } from '@app/interfaces';
import { AuthService, NotifyService } from '@app/services';
import { BenefitChangeRequest } from '@models/benefits/benefit-change-request.model';
import { BenefitPlan } from '@models/employee/benefits/benefit-plan.model';

const CHANGE_REQUEST_STATUSES = {
    draft: 'draft',
    pending: 'pending',
    declined: 'declined',
    approved: 'accepted',
};

@Component({
    selector: 'app-benefits-change-request-banner',
    templateUrl: './benefits-change-request-banner.template.html',
    styleUrls: ['./benefits-change-request-banner.style.scss'],
})
export class BenefitsChangeRequestBanner implements OnInit {
    @Input() employeeBenefitPlan: BenefitPlan;

    changeRequestStatuses = CHANGE_REQUEST_STATUSES;
    changeRequestStatusBadgeOptions: BadgeOptions;
    showAdminNote: string | null;
    allChangeRequests: BenefitChangeRequest[] = [];

    constructor(
        public auth: AuthService,
        private benefitChangeRequestService: BenefitChangeRequestService,
        protected notify: NotifyService
    ) {}

    ngOnInit(): void {
        this.getAllChangeRequestsBasedOnAcknowledgement();
    }

    onDeleteChangeRequest(changeRequest: BenefitChangeRequest): void {
        changeRequest
            .param('company', this.auth.company.id)
            .param('benefitPlan', this.employeeBenefitPlan.benefitPlanId)
            .delete()
            .then(() => {
                this.notify.success('account.benefits.changeRequestDeleted');
                // this page is state heavy, easiest (for now) is a refresh from compoennt
                window.location.reload();
            })
            .catch((err) => {
                this.notify.error(err.message || 'account.benefits.couldNotDeleteChangeRequest');
            });
    }
    acknowledge(changeRequest: BenefitChangeRequest): void {
        const benefitPlanId = this.employeeBenefitPlan.benefitPlanId;

        this.benefitChangeRequestService
            .onChangeRequestStatusAcknowledge(benefitPlanId, changeRequest.id)
            .then(() => {
                this.notify.success('account.benefits.changeRequestAcknowledged');
                this.getAllChangeRequestsBasedOnAcknowledgement();
            })
            .catch((err) => {
                this.notify.error(err.message || 'account.benefits.couldNotAcknowledgeChangeRequest');
            });
    }

    public getAllChangeRequestsBasedOnAcknowledgement(): void {
        this.benefitChangeRequestService
            .getAllChangeRequestsBasedOnAcknowledgement(this.employeeBenefitPlan.benefitPlanId)
            .then((allChangeRequests: BenefitChangeRequest[]) => {
                this.allChangeRequests = allChangeRequests;
            })
            .catch((err) => {
                this.notify.error(err.message || 'account.benefits.couldNotFetchStatus');
            });
    }
}
